import { CheckCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Checkbox, Form } from 'antd';
import classNames from 'classnames';

import styles from './ExtranetContacts.module.scss';
import type { EmailTypeColumn } from './columns';

type EmailTypeCellProps = {
  isEditMode: boolean;
  namePath: number;
  column: EmailTypeColumn;
  checked: boolean;
  checkedCount: number;
};

const EmailTypeIndicator = ({ checked }: { checked?: boolean }) =>
  checked ? <CheckCircleOutlined /> : <CloseOutlined />;

export const EmailTypeCell = ({
  isEditMode,
  namePath,
  column,
  checked,
  checkedCount,
}: EmailTypeCellProps) => {
  const disabled = Boolean(column.required) && checked && checkedCount <= 1;

  return (
    <div
      className={classNames(styles.cell, {
        [styles.cellEnabled]: checked,
        [styles.cellDisabled]: !checked,
      })}
    >
      <Form.Item name={[namePath, column.key]} valuePropName="checked" noStyle>
        {isEditMode ? <Checkbox disabled={disabled} /> : <EmailTypeIndicator />}
      </Form.Item>
    </div>
  );
};
